import { render } from "./CxLegendItem.vue?vue&type=template&id=6ffdbc1a&scoped=true"
import script from "./CxLegendItem.vue?vue&type=script&lang=js"
export * from "./CxLegendItem.vue?vue&type=script&lang=js"

import "./CxLegendItem.vue?vue&type=style&index=0&id=6ffdbc1a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffdbc1a"]])

export default __exports__